import $ from "jquery";

$('.faq_question').on('click', function(){
  if($(this).hasClass('open')) {
    $(this).removeClass('open');
    $(this).next().slideUp();
  } else {
    $(this).addClass('open');
    $(this).next().slideDown();
  }
});